<template>
  <UsuariosExtLayout title="Actualizar datos tarjeta" subtitle="Mantén tu información al día"
    description="Complete el formulario paso a paso para actualizar los datos asociados a su tarjeta." :show-back="true"
    narrow>
    <div class="conecta-form-card">
      <form-wizard ref="wizard" title="Actualizar datos tarjeta" subtitle="Mantén tu información al día"
        @on-complete="submitForm" color="#05A85A" back-button-text="Anterior" next-button-text="Siguiente"
        finish-button-text="Actualizar Datos">
        <!-- Paso 1: Número de Tarjeta -->
        <tab-content title="Número de Tarjeta" :before-change="validateStep1" icon="fas fa-credit-card">
          <div class="mb-3">
            <label for="noTarjeta" class="conecta-form-label">
              <i class="fas fa-credit-card"></i>
              No. Tarjeta <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control conecta-form-control" id="noTarjeta" v-model="formData.noTarjeta"
              :class="{ 'is-invalid': errors.noTarjeta }" placeholder="Ingrese el número de tarjeta" />
            <div v-if="errors.noTarjeta" class="conecta-invalid-feedback">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ errors.noTarjeta }}
            </div>
          </div>
        </tab-content>

        <!-- Paso 2: Datos del Usuario -->
        <tab-content title="Datos del Usuario" :before-change="validateStep2" icon="fas fa-user">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="tipoDocumento" class="conecta-form-label">
                <i class="fas fa-id-card"></i>
                Tipo de Documento <span class="text-danger">*</span>
              </label>
              <select class="form-control conecta-form-control" id="tipoDocumento" v-model="formData.tipoDocumento"
                :class="{ 'is-invalid': errors.tipoDocumento }">
                <option value="">Seleccione un tipo</option>
                <option v-for="tipo in tiposDocumentos" :key="tipo.id" :value="tipo.numeracion">
                  {{ tipo.descripcion }}
                </option>
              </select>
              <div v-if="errors.tipoDocumento" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.tipoDocumento }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="documento" class="conecta-form-label">
                <i class="fas fa-id-card"></i>
                Número de Documento <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control conecta-form-control" id="documento" v-model="formData.documento"
                :class="{ 'is-invalid': errors.documento }" placeholder="Número de documento"
                @input="validarDocumentoIdentidad()" />
              <div v-if="errors.documento" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.documento }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="nombres" class="conecta-form-label">
                <i class="fas fa-user"></i>
                Nombres <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control conecta-form-control" id="nombres" v-model="formData.nombres"
                :class="{ 'is-invalid': errors.nombres }" placeholder="Sus nombres" />
              <div v-if="errors.nombres" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.nombres }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="apellidos" class="conecta-form-label">
                <i class="fas fa-user"></i>
                Apellidos <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control conecta-form-control" id="apellidos" v-model="formData.apellidos"
                :class="{ 'is-invalid': errors.apellidos }" placeholder="Sus apellidos" />
              <div v-if="errors.apellidos" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.apellidos }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="email" class="conecta-form-label">
                <i class="fas fa-envelope"></i>
                Email <span class="text-danger">*</span>
              </label>
              <input type="email" class="form-control conecta-form-control" id="email" v-model="formData.email"
                :class="{ 'is-invalid': errors.email }" placeholder="correo@ejemplo.com" />
              <div v-if="errors.email" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.email }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="telefono" class="conecta-form-label">
                <i class="fas fa-phone"></i>
                Teléfono <span class="text-danger">*</span>
              </label>
              <input type="tel" class="form-control conecta-form-control" id="telefono" v-model="formData.telefono"
                :class="{ 'is-invalid': errors.telefono }" placeholder="300 1234567" />
              <div v-if="errors.telefono" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.telefono }}
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6 mb-3">
              <label for="municipio" class="conecta-form-label">
                <i class="fas fa-city"></i>
                Municipio <span class="text-danger">*</span>
              </label>
              <v-select v-model="municipio" :options="ciudades" label="nombre"
                :class="{ 'is-invalid': errors.municipio }" placeholder="Seleccione un municipio"
                @input="selectMunicipio">
                <template slot="no-options">
                  <span>No hay municipios disponibles</span>
                </template>
              </v-select>
              <div v-if="errors.municipio" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.municipio }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="direccion" class="conecta-form-label">
                <i class="fas fa-map-marker-alt"></i>
                Dirección <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control conecta-form-control" id="direccion" v-model="formData.direccion"
                :class="{ 'is-invalid': errors.direccion }" placeholder="Dirección completa" />
              <div v-if="errors.direccion" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.direccion }}
              </div>
            </div>
          </div>
        </tab-content>

        <!-- Paso 3: Autorización y Documentos -->
        <tab-content title="Autorización y Documentos" :before-change="validateStep3" icon="fas fa-file-contract">
          <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="autorizacion" v-model="formData.autorizacion"
                :class="{ 'is-invalid': errors.autorizacion }" />
              <label class="form-check-label conecta-form-check-label" for="autorizacion">
                <i class="fas fa-shield-alt mr-1"></i>
                <a href="/tratamiento-datos-personales" target="_blank">
                  Autorizo el tratamiento de mis datos personales
                </a>
                <span class="text-danger">*</span>
              </label>
              <div v-if="errors.autorizacion" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.autorizacion }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="terminos" v-model="formData.terminos"
                :class="{ 'is-invalid': errors.terminos }" />
              <label class="form-check-label conecta-form-check-label" for="terminos">
                <i class="fas fa-file-contract mr-1"></i>
                <a href="/terminos-condiciones-tarjetas" target="_blank">
                  Acepto los términos y condiciones
                </a>
                <span class="text-danger">*</span>
              </label>
              <div v-if="errors.terminos" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ errors.terminos }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="fotocopiaCedula" class="conecta-form-label">
              <i class="fas fa-file-upload"></i>
              Fotocopia de Cédula <span class="text-danger">*</span>
            </label>
            <input type="file" class="form-control conecta-form-control" id="fotocopiaCedula" ref="fotocopiaCedula"
              @change="getFile" accept="application/msword,application/pdf,application/rtf,image/*"
              :class="{ 'is-invalid': errors.fotocopiaCedula }" />
            <div v-if="errors.fotocopiaCedula" class="conecta-invalid-feedback">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ errors.fotocopiaCedula }}
            </div>
            <small class="conecta-form-hint d-block">
              <i class="fas fa-info-circle mr-1"></i>
              Formatos aceptados: PDF, Word, RTF o imágenes. Tamaño máximo: 2MB
            </small>
            <div v-if="fileDoc" class="mt-2">
              <span class="conecta-badge-success">
                <i class="fas fa-check-circle mr-1"></i>
                Archivo seleccionado: {{ fileDoc.name }}
              </span>
            </div>
          </div>

          <div class="mb-3 mt-4">
            <div class="d-flex justify-content-center">
              <div id="recaptcha-container-datos"></div>
            </div>
            <div v-if="errors.recaptcha" class="conecta-invalid-feedback text-center mt-2">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ errors.recaptcha }}
            </div>
          </div>
        </tab-content>
      </form-wizard>

      <div class="d-flex justify-content-center mt-3">
        <button type="button" class="btn conecta-btn-outline px-4 py-2" @click="resetForm">
          <i class="fas fa-undo mr-2"></i>
          Limpiar formulario
        </button>
      </div>
    </div>
  </UsuariosExtLayout>
</template>

<script>
import axios from "axios";
import UsuariosExtLayout from "../../components/usuariosExt/UsuariosExtLayout.vue";

export default {
  name: "DatosTarjetasForm",

  components: {
    UsuariosExtLayout,
  },

  data() {
    return {
      formData: {
        noTarjeta: "",
        tipoDocumento: "",
        documento: "",
        nombres: "",
        apellidos: "",
        email: "",
        telefono: "",
        direccion: "",
        municipio: "",
        autorizacion: false,
        terminos: false,
      },
      tiposDocumentos: [],
      tarjetaValida: "",
      errors: {},
      isSubmitting: false,
      fileDoc: null,
      ciudades: [],
      municipio: null,
      recaptchaToken: null,
      recaptchaWidgetId: null,
      personaTarjeta: null,
    };
  },

  mounted() {
    this.getCiudades();
    this.getTiposDocumentos();
    this.loadRecaptcha();
  },

  beforeDestroy() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha) {
      try {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      } catch (e) {
        console.log("Error al resetear reCAPTCHA:", e);
      }
    }
  },

  methods: {
    async validateStep1() {
      this.errors = {};
      let isValid = true;

      if (!this.formData.noTarjeta.trim()) {
        this.errors.noTarjeta = "Por favor, ingrese el número de su tarjeta para continuar";
        isValid = false;
      } else if (this.formData.noTarjeta.trim().length < 5) {
        this.errors.noTarjeta = "El número de tarjeta debe tener al menos 5 caracteres";
        isValid = false;
      }

      if (!isValid) {
        this.$swal.fire({
          icon: "error",
          title: "Campo Requerido",
          text: "Por favor, complete el campo requerido para continuar",
        });
      }

      let valTarjeta = await this.validarTarjeta();

      if (!valTarjeta) {
        this.$swal.fire({
          icon: "error",
          title: "Tarjeta no válida",
          text: "Por favor, ingrese una tarjeta válida",
        });
        isValid = false;
      }

      if (isValid) {
        await this.getPersonaTarjeta();
      }
      return isValid;
    },

    validateStep2() {
      this.errors = {};
      let isValid = true;

      if (!this.formData.tipoDocumento) {
        this.errors.tipoDocumento = "Por favor, seleccione el tipo de documento de identidad";
        isValid = false;
      }

      if (!this.formData.documento.trim()) {
        this.errors.documento = "Por favor, ingrese su número de documento de identidad";
        isValid = false;
      } else if (this.formData.documento.trim().length < 5) {
        this.errors.documento = "El número de documento debe tener al menos 5 caracteres";
        isValid = false;
      }

      if (!this.formData.nombres.trim()) {
        this.errors.nombres = "Por favor, ingrese sus nombres completos";
        isValid = false;
      } else if (this.formData.nombres.trim().length < 2) {
        this.errors.nombres = "Los nombres deben tener al menos 2 caracteres";
        isValid = false;
      }

      if (!this.formData.apellidos.trim()) {
        this.errors.apellidos = "Por favor, ingrese sus apellidos completos";
        isValid = false;
      } else if (this.formData.apellidos.trim().length < 2) {
        this.errors.apellidos = "Los apellidos deben tener al menos 2 caracteres";
        isValid = false;
      }

      if (!this.formData.email.trim()) {
        this.errors.email = "Por favor, ingrese su dirección de correo electrónico";
        isValid = false;
      } else if (!this.isValidEmail(this.formData.email)) {
        this.errors.email = "El formato del email no es válido. Ejemplo: correo@ejemplo.com";
        isValid = false;
      }

      if (!this.formData.telefono.trim()) {
        this.errors.telefono = "Por favor, ingrese su número de teléfono de contacto";
        isValid = false;
      } else if (this.formData.telefono.trim().length < 7) {
        this.errors.telefono = "El número de teléfono debe tener al menos 7 dígitos";
        isValid = false;
      }

      if (!this.formData.direccion.trim()) {
        this.errors.direccion = "Por favor, ingrese su dirección de residencia completa";
        isValid = false;
      } else if (this.formData.direccion.trim().length < 10) {
        this.errors.direccion = "La dirección debe tener al menos 10 caracteres para ser válida";
        isValid = false;
      }

      if (!this.municipio || !this.municipio.id) {
        this.errors.municipio = "Por favor, seleccione un municipio de la lista";
        isValid = false;
      }

      if (!isValid) {
        this.$swal.fire({
          icon: "error",
          title: "Campos Incompletos",
          text: "Por favor, complete correctamente todos los campos requeridos",
        });
      }

      return isValid;
    },

    validateStep3() {
      this.errors = {};
      let isValid = true;

      if (!this.formData.autorizacion) {
        this.errors.autorizacion =
          "Debe marcar la casilla para autorizar el tratamiento de sus datos personales. Esto es obligatorio para continuar.";
        isValid = false;
      }

      if (!this.formData.terminos) {
        this.errors.terminos =
          "Debe aceptar los términos y condiciones marcando la casilla correspondiente. Esto es obligatorio para continuar.";
        isValid = false;
      }

      if (!this.fileDoc) {
        this.errors.fotocopiaCedula =
          "Debe adjuntar una fotocopia de su cédula de identidad. Formatos aceptados: PDF, Word, RTF o imágenes (máximo 2MB)";
        isValid = false;
      }

      if (!this.recaptchaToken) {
        this.errors.recaptcha = "Por favor, complete la verificación reCAPTCHA para continuar";
        isValid = false;
      }

      if (!isValid) {
        this.$swal.fire({
          icon: "error",
          title: "Información Pendiente",
          text: "Por favor, complete todas las autorizaciones, adjunte el documento requerido y complete la verificación reCAPTCHA",
        });
      }

      return isValid;
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    getFile(e) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        if (this.validaArchivo(file)) {
          this.fileDoc = file;
          this.errors.fotocopiaCedula = null;
        } else {
          this.fileDoc = null;
          if (this.$refs.fotocopiaCedula) {
            this.$refs.fotocopiaCedula.value = "";
          }
        }
      }
    },

    validaArchivo(file) {
      let flag = true;
      const tiposPermitidos = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/rtf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];

      if (file.size > 2048000) {
        flag = false;
        this.$swal.fire({
          icon: "error",
          title: "Archivo Demasiado Grande",
          text: "El archivo es demasiado grande. El tamaño máximo permitido es 2MB. Por favor, comprima o seleccione un archivo más pequeño.",
        });
        this.errors.fotocopiaCedula =
          "El archivo excede el tamaño máximo de 2MB. Por favor, seleccione un archivo más pequeño.";
      } else if (
        !tiposPermitidos.includes(file.type) &&
        !file.name.match(/\.(pdf|doc|docx|rtf|jpg|jpeg|png|gif)$/i)
      ) {
        flag = false;
        this.$swal.fire({
          icon: "error",
          title: "Formato No Válido",
          text: "El formato del archivo no es válido. Solo se aceptan: PDF, Word, RTF o imágenes (JPG, PNG, GIF)",
        });
        this.errors.fotocopiaCedula =
          "El formato del archivo no es válido. Formatos aceptados: PDF, Word (.doc, .docx), RTF o imágenes (JPG, PNG, GIF)";
      }
      return flag;
    },

    validateForm() {
      this.errors = {};
      let isValid = true;

      if (!this.formData.noTarjeta.trim()) {
        this.errors.noTarjeta = "El número de tarjeta es obligatorio";
        isValid = false;
      }

      if (!this.formData.tipoDocumento) {
        this.errors.tipoDocumento = "El tipo de documento es obligatorio";
        isValid = false;
      }

      if (!this.formData.documento.trim()) {
        this.errors.documento = "El documento es obligatorio";
        isValid = false;
      }

      if (!this.formData.nombres.trim()) {
        this.errors.nombres = "Los nombres son obligatorios";
        isValid = false;
      }

      if (!this.formData.apellidos.trim()) {
        this.errors.apellidos = "Los apellidos son obligatorios";
        isValid = false;
      }

      if (!this.formData.email.trim()) {
        this.errors.email = "El email es obligatorio";
        isValid = false;
      } else if (!this.isValidEmail(this.formData.email)) {
        this.errors.email = "Ingrese un email válido";
        isValid = false;
      }

      if (!this.formData.telefono.trim()) {
        this.errors.telefono = "El teléfono es obligatorio";
        isValid = false;
      }

      if (!this.formData.direccion.trim()) {
        this.errors.direccion = "La dirección es obligatoria";
        isValid = false;
      }

      if (!this.municipio || !this.municipio.id) {
        this.errors.municipio = "El municipio es obligatorio";
        isValid = false;
      }

      if (!this.formData.autorizacion) {
        this.errors.autorizacion = "Debe autorizar el tratamiento de datos personales";
        isValid = false;
      }

      return isValid;
    },

    async submitForm() {
      if (!this.validateStep1() || !this.validateStep2() || !this.validateStep3()) {
        this.$swal.fire({
          icon: "error",
          title: "Error de Validación",
          text: "Por favor, corrija los errores en el formulario",
        });
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        formData.append("no_externo", this.formData.noTarjeta);
        formData.append("tipoDocumento", this.formData.tipoDocumento);
        formData.append("documento", this.formData.documento);
        formData.append("nombres", this.formData.nombres);
        formData.append("apellidos", this.formData.apellidos);
        formData.append("email", this.formData.email);
        formData.append("telefono", this.formData.telefono);
        formData.append("direccion", this.formData.direccion);
        formData.append("municipio_id", this.municipio ? this.municipio.id : null);
        formData.append("municipio", this.municipio ? this.municipio.nombre : null);
        formData.append("autorizacion", this.formData.autorizacion ? 1 : 0);
        formData.append("terminos", this.formData.terminos ? 1 : 0);
        formData.append("tarjeta_valida", this.tarjetaValida);
        formData.append("recaptcha_token", this.recaptchaToken);

        if (this.fileDoc) {
          formData.append("fotocopia_cedula", this.fileDoc);
        }

        let response = await axios.post("/api/actualizarDatosTarjeta", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        let res = response.data;
        if (res.status == 1) {
          this.$swal.fire({
            icon: "success",
            title: "Éxito",
            text: res.mensaje,
          });
          this.resetForm();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error al actualizar los datos",
            text: res.error,
          });
        }
      } catch (error) {
        console.error("Error al actualizar datos:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar. Intente nuevamente.",
        });
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.formData = {
        noTarjeta: "",
        tipoDocumento: "",
        documento: "",
        nombres: "",
        apellidos: "",
        email: "",
        telefono: "",
        direccion: "",
        municipio_id: null,
        autorizacion: false,
        terminos: false,
      };
      this.errors = {};
      this.fileDoc = null;
      this.municipio = null;
      this.recaptchaToken = null;
      if (this.$refs.fotocopiaCedula) {
        this.$refs.fotocopiaCedula.value = "";
      }
      if (this.recaptchaWidgetId !== null && window.grecaptcha) {
        try {
          window.grecaptcha.reset(this.recaptchaWidgetId);
        } catch (e) {
          console.log("Error al resetear reCAPTCHA:", e);
        }
      }
      if (this.$refs.wizard) {
        this.$refs.wizard.reset();
      }
    },

    async getCiudades() {
      try {
        const response = await axios.get("/api/ciudades/lista");
        this.ciudades = response.data;
      } catch (error) {
        console.error("Error al obtener ciudades:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar las ciudades. Por favor, recargue la página.",
        });
      }
    },

    selectMunicipio() {
      if (this.municipio && this.municipio.id) {
        this.formData.municipio_id = this.municipio.id;
        this.errors.municipio = null;
      } else {
        this.formData.municipio_id = null;
      }
    },

    async validarTarjeta() {
      let response = await axios.get("/api/comprobarTarjetaNRTEC/" + this.formData.noTarjeta);
      let res = response.data;
      if (res.code == 0) {
        this.tarjetaValida = res.num_tarjeta_interno;
        return true;
      }
      return false;
    },

    async getPersonaTarjeta() {
      let response = await axios.get("/api/getDatosTarjetaPersona", {
        params: { no_tarjeta: this.tarjetaValida },
      });
      let res = response.data;
      this.personaTarjeta = res.usuario_trj;
    },

    validarDocumentoIdentidad() {
      if (this.personaTarjeta) {
        if (this.formData.documento === this.personaTarjeta.n_documento) {
          this.formData.documento = this.personaTarjeta.n_documento;
          this.formData.nombres = this.personaTarjeta.nombres;
          this.formData.apellidos = this.personaTarjeta.apellidos;
          this.formData.email = this.personaTarjeta.email;
          this.formData.telefono = this.personaTarjeta.telefono;
          this.formData.direccion = this.personaTarjeta.direccion;
          this.formData.municipio_id = this.personaTarjeta.ciudad_id;
          this.municipio = this.ciudades.find(municipio => municipio.id === this.personaTarjeta.ciudad_id);
          return true;
        } else {
          return false;
        }
      }
      return false;
    },

    async getTiposDocumentos() {
      let response = await axios.get("/api/lista/2");
      let res = response.data;
      this.tiposDocumentos = res;
    },

    loadRecaptcha() {
      if (window.grecaptcha && window.grecaptcha.render) {
        this.renderRecaptcha();
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaLoadedDatos&render=explicit";
      script.async = true;
      script.defer = true;

      window.vueRecaptchaLoadedDatos = () => {
        this.renderRecaptcha();
      };

      document.head.appendChild(script);
    },

    renderRecaptcha() {
      this.$nextTick(() => {
        if (window.grecaptcha && document.getElementById("recaptcha-container-datos")) {
          try {
            this.recaptchaWidgetId = window.grecaptcha.render("recaptcha-container-datos", {
              sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
              callback: this.onRecaptchaSuccess,
              "expired-callback": this.onRecaptchaExpired,
              "error-callback": this.onRecaptchaError,
              theme: "light",
              size: "normal",
            });
          } catch (e) {
            console.error("Error al renderizar reCAPTCHA:", e);
          }
        }
      });
    },

    onRecaptchaSuccess(token) {
      this.recaptchaToken = token;
      this.errors.recaptcha = null;
    },

    onRecaptchaExpired() {
      this.recaptchaToken = null;
      this.errors.recaptcha = "La verificación reCAPTCHA ha expirado. Por favor, vuelva a verificar.";
      if (this.recaptchaWidgetId !== null && window.grecaptcha) {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      }
    },

    onRecaptchaError() {
      this.recaptchaToken = null;
      this.errors.recaptcha = "Error en la verificación reCAPTCHA. Por favor, intente nuevamente.";
    },
  },
};
</script>

<style scoped lang="scss">


::v-deep .wizard-nav {
  margin-bottom: 1.5rem;
}

::v-deep .wizard-icon-circle {
  border-color: #05a85a !important;
}

::v-deep .wizard-icon-container {
  background-color: #05a85a !important;
}

::v-deep .stepTitle.active {
  color: #0d3d2b !important;
}

::v-deep .wizard-progress-bar {
  background-color: #05a85a !important;
}

::v-deep .v-select .vs__dropdown-toggle {
  border-radius: 0.65rem;
  border-color: rgba(5, 168, 90, 0.2);
  min-height: 38px;
}

::v-deep .v-select .vs__dropdown-menu {
  background-color: #fff;
}

::v-deep .v-select .vs__dropdown-option {
  color: #212529;
}

::v-deep .v-select .vs__dropdown-option--highlight {
  background: #05a85a;
  color: #fff;
}

::v-deep .v-select .vs__selected {
  color: #212529;
}

::v-deep .form-control.is-invalid,
::v-deep .v-select.is-invalid .vs__dropdown-toggle {
  border-color: #c0392b;
}

#recaptcha-container-datos {
  margin: 1rem 0;
}

@media (max-width: 576px) {
  #recaptcha-container-datos {
    transform: scale(0.85);
    transform-origin: center;
  }
}
</style>
